import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors, text, verticalGutter } from '../../styles';

const Badge = ({ as = 'strong', children, ...rest }) => {
  const StyledBadge = styled[as]`
    position: absolute;
    left: 0px;
    right: auto;
    top: 0;
    display: inline-block;
    padding: 0.75rem ${verticalGutter * 0.75}rem 0.5rem;
    padding-right: ${verticalGutter * 2}rem;
    color: ${colors.yellow};
    font-family: ${text.fontNameHeader};
    font-style: oblique;
    font-size: ${text.small};
    line-height: ${text.lineHeight};
    letter-spacing: 0.025em;
    word-break: break-word;
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: ${verticalGutter * -1}rem;
      right: 0;
      width: 100%;
      height: 100%;
      background: ${colors.green};
      border-radius: 0 0 0.5rem 0;
      transform: skewX(-35deg);
      z-index: -1;
    }
  `;

  return <StyledBadge {...rest}>{children}</StyledBadge>;
};

Badge.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  as: PropTypes.string
};

export default Badge;



// WEBPACK FOOTER //
// ./src/components/Badge/Badge.js